import { splitMoney } from "@/lib/money"
import { cn } from "@/lib/utils"

interface MoneyProps {
  value: number | string | null | undefined
  className?: string
}

/**
 * Big-number money: "Bs. 12.345" with the decimals smaller and muted (",50").
 * For summary cards only; in tables and sentences use formatBs().
 */
export function Money({ value, className }: MoneyProps) {
  const { negative, integer, decimals } = splitMoney(value)
  return (
    <span className={cn("whitespace-nowrap", className)}>
      {negative ? "-" : ""}Bs. {integer}
      <span className="text-[0.6em] font-semibold text-muted-foreground">,{decimals}</span>
    </span>
  )
}
